import { render, staticRenderFns } from "./dg-step.vue?vue&type=template&id=66a41ca0&scoped=true"
import script from "./dg-step.vue?vue&type=script&lang=js"
export * from "./dg-step.vue?vue&type=script&lang=js"
import style0 from "./dg-step.vue?vue&type=style&index=0&id=66a41ca0&prod&lang=less&scoped=true"
import style1 from "./dg-step.vue?vue&type=style&index=1&id=66a41ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a41ca0",
  null
  
)

export default component.exports